import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CommunicationService } from '../../../proxy/communications/communication.service';
import { CommunicationDto } from '../../../proxy/communications/models';
import { Subscription, interval } from 'rxjs';
import { APP_ICONS } from '../../icons/app-icons';
import { CommunicationService as SignalRCommunicationService } from '../../services/comunication.service';

@Component({
  selector: 'app-mobile-communication-banner',
  templateUrl: './mobile-communication-banner.component.html',
  standalone: false
})
export class MobileCommunicationBannerComponent implements OnInit, OnDestroy {
  APP_ICONS = APP_ICONS;
  activeMessages: CommunicationDto[] = [];
  currentIndex = 0;
  rotationSubscription?: Subscription;
  isLoading = true;
  hasLoadError = false;
  showModal = false;
  currentModalImage: string | null = null;
  hasSeenModal = false;

  constructor(
    private communicationService: CommunicationService,
    private signalRService: SignalRCommunicationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadActiveMessages();
    // Escuchar eventos de SignalR para actualizaciones en tiempo real
    this.signalRService.on('CommunicationUpdated', () => {
      this.loadActiveMessages();
    });
  }

  ngOnDestroy(): void {
    this.stopRotation();
  }

  loadActiveMessages() {
    this.isLoading = true;
    this.communicationService.getActiveList({ skipHandleError: true }).subscribe({
      next: (result) => {
        this.activeMessages = result || [];
        this.currentIndex = 0;
        this.isLoading = false;
        this.hasLoadError = false;
        
        // Check if there's a communication with an image and show modal
        if (!this.hasSeenModal && this.activeMessages.length > 0) {
          const firstWithImage = this.activeMessages.find(msg => msg.imageUrl);
          if (firstWithImage) {
            this.currentModalImage = firstWithImage.imageUrl;
            this.showModal = true;
          }
        }
        
        if (this.activeMessages.length > 1) {
          this.startRotation();
        } else {
          this.stopRotation();
        }
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.isLoading = false;
        this.hasLoadError = true;
        // No limpiar activeMessages en error para mantener el último estado válido
        this.cdr.detectChanges();
      }
    });
  }

  closeModal() {
    this.showModal = false;
    this.hasSeenModal = true;
    this.currentModalImage = null;
  }

  startRotation() {
    this.stopRotation();
    // Rotar cada 5 segundos
    this.rotationSubscription = interval(5000).subscribe(() => {
      this.currentIndex = (this.currentIndex + 1) % this.activeMessages.length;
      this.cdr.detectChanges();
    });
  }

  next() {
    this.stopRotation();
    if (this.currentIndex < this.activeMessages.length - 1) {
      this.currentIndex++;
      this.cdr.detectChanges();
    }
    this.startRotation();
  }

  prev() {
    this.stopRotation();
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.cdr.detectChanges();
    }
    this.startRotation();
  }

  stopRotation() {
    if (this.rotationSubscription) {
      this.rotationSubscription.unsubscribe();
      this.rotationSubscription = undefined;
    }
  }

  get currentMessage(): string {
    if (this.activeMessages.length === 0) return '';
    return this.activeMessages[this.currentIndex]?.message || '';
  }
}
